import type { Identity } from "@wb/ui/analytics/useIdentity";
import posthog from "posthog-js";

export const identity: Identity = (id, email) => {
  if (!email) {
    posthog.identify(id);
    return;
  }

  posthog.identify(id, {
    email,
  });
};
